<template>
  <div class="auth-error-layer">
    <div class="auth-error-layer__icon">⚠️</div>
    <h4 class="auth-error-layer__title">신원 확인 실패</h4>
    <p class="auth-error-layer__desc">{{ message }}</p>
  </div>
</template>

<script>
// 오버레이 신원(broadcast_token) 확인 실패 시 표시. 로딩("집에서 나오는중") 위를 덮어 원인을 알린다.
export default {
  props: {
    message: {
      type: String,
      default: "OBS 링크가 만료되었거나 유효하지 않습니다. 제어판에서 링크를 다시 발급해주세요.",
    },
  },
};
</script>

<style scoped>
.auth-error-layer {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 16px;
  background: rgba(30, 24, 40, 0.92);
  z-index: 10;
}
.auth-error-layer__icon {
  font-size: 40px;
  line-height: 1;
  margin-bottom: 12px;
}
.auth-error-layer__title {
  color: #ff8a8a;
  font-family: maplestory;
  margin: 0 0 8px;
}
.auth-error-layer__desc {
  color: #e0d8ec;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  max-width: 280px;
}
</style>
